/* eslint-disable max-len */
import React from 'react';

const LineSpacingIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
    <path d="M9.2 7h7.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm0 3h7.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm0 3h7.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm0-9h7.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2z" />
    <path d="M5.854 4.707L7 5.853l.707-.707-2-2-.005-.003-.157-.104L5.354 3l-.191.039-.157.104L5 3.146l-2 2s.708.706.707.707l1.147-1.146v8.586l-1.146-1.146-.707.707 2 2 .162.108.189.038.193-.039.162-.107 2-2L7 12.147l-1.146 1.146V4.707z" />
  </svg>
);

export default LineSpacingIcon;
